/* Casa Lizette — sticky add-to-cart bar: IntersectionObserver on the real buy box, no scroll polling. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var anchor = document.querySelector('[data-buy-box-anchor]');
    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (!anchor || !stickyBar) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    var stickyButton = stickyBar.querySelector('[data-sticky-atc-button]');
    var realSubmit = document.querySelector('[data-add-to-cart-button]');
    if (stickyButton && realSubmit) {
      stickyButton.addEventListener('click', function () {
        realSubmit.click();
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  });
})();
